import { useMap } from "react-leaflet";

export const MapCenter = ({ passNewLon, passNewLat, defaultCenter }) => {
	const map = useMap();

	if (passNewLat === undefined) map.flyTo(defaultCenter, 6);
	else map.flyTo([passNewLat, passNewLon], 13);
};
